<template>
  <BaseModal overlay-class="other_modals net_prob">
    <div class="content">
      <BaseImage src="/static/images/other/maintenance_icon.svg" alt="Maintenance" />

      <h3 class="title">{{ $_translations.value.modal_maintenance_title }}</h3>

      <p>{{ $_translations.value.modal_maintenance_description }}</p>

      <BaseButton @click:button="$emit('redirect:homePage')">
        {{ $_translations.value.modal_maintenance_button_proceed }}
      </BaseButton>
    </div>
  </BaseModal>
</template>

<script setup>
import BaseModal from '@/components/modal/BaseModal.vue';
import BaseImage from '@/components/image/BaseImage.vue';
import BaseButton from '@/components/button/BaseButton.vue';

defineEmits(['redirect:homePage']);
</script>
